import Vue from 'vue'
import Meta from 'vue-meta'
import App from './App.vue'
import router from './router'
import store from "./store"

//import vConsole from "./utils/vconsole"

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

Vue.use(Meta)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  // vConsole,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
